import React, { useContext } from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import SignInButton from './signinButton';
import { AppKeys } from '../../core/localization';
import { LocaleCtx } from '../../contexts/locale.context';

const UnauthenticatedPage: React.FC = () => {
  const { translate } = useContext(LocaleCtx);
  const title = translate(AppKeys.unauthenticated_title);
  const content: JSX.Element = (
    <div className="layout__content__withmargins">
      <p>{translate(AppKeys.unauthenticated_desc)}</p>
      <SignInButton />
    </div>
  );
  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={content}
      menu={<Menu title={title} />}
      isSidebarDisabled={false}
    />
  );
};

export default UnauthenticatedPage;
